var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseLink',{staticClass:"promotion-card",attrs:{"data-external":"promotion-card","link":_vm.promoLink}},[(_vm.promoImageSrc)?_c('BaseImage',{staticClass:"promotion-card__image",attrs:{"image-tag":"nuxt-img","src":_vm.promoImageSrc,"alt":_vm.promoImageAlt}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }